import gql from "graphql-tag";
import Config from "config";

export const GET_OFFICES_SELECT = gql`
  query {
    offices(limit: ${Config.get("pageLimit.noLimit")}) {
      data {
        id
        name
        regroupement_agence
        use_half_days
      }
    }
  }
`;

export const GET_USER_OFFICES = gql`
  query getUserOffices {
    me {
      id
      profile
      offices {
        id
        name
      }
    }
  }
`;

export const GET_CONTRACTOR_RESERVATION_VISIBILITY = gql`
  query GetContractorReservationVisibility($id: ID!) {
    user(id: $id) {
      id
      contractors {
        id
        active
        is_reservation_enabled
      }
    }
  }
`;
